import appConfig from "config.json";
import { isCurrentPathPresent, mapString } from "utils";
import { dynamicallyLoadScript } from "./externalScripts";

export const loadRoomsAvailabilityScript = (brand) => {
	const brandConfiguration = appConfig.brands[brand] || {};
	const proactiveWasTriggered =
		window.sessionStorage.getItem("navigationProactiveTriggered") || false;
	if (
		(brandConfiguration?.validateRoomsAvailability &&
			!isCurrentPathPresent(
				brandConfiguration?.pathsToValidateRoomsAvailability
			)) ||
		proactiveWasTriggered ||
		!brandConfiguration?.validateRoomsAvailability
	) {
		return;
	}
	dynamicallyLoadScript(mapString(appConfig.roomsAvailabilityScript, brand));
};
